<template>
	<div class="setting-page order  all-order ">
		<top-bar :title="i18n.t('allOrder.title')" @back="back"></top-bar>

		<div class="order-top flex-center-start">
			<div class="sub-title flex">
				<div class="tab" :class="tabActive == 1 ? 'active' : ''" @click="changeTab(1)">
					{{$t(`allOrder.tab1_${tabIndex}`)}}({{dataTotal}})
				</div>
				<div class="tab" :class="tabActive == 2 ? 'active' : ''" @click="changeTab(2)">
					{{$t(`allOrder.tab2_${tabIndex}`)}}
				</div>
			</div>

		</div>


		<div class="order-list">
			<List
				v-if="orderList.length > 0"
				v-model="loading"
				:finished="finished"
				:finished-text="i18n.t('common.noMore')"
				@load="onLoad">
				<!--现货-->
				<div class="trade-list" v-if="tabIndex == 1">
						<div class="list" v-for="(item, i) in orderList" :key="i" @click="toDetail(item)">
							<div class="flex-center-between">
								<div class="list-title flex-center">
									<span>{{item.Currency.ShortName}}/USDT</span>
								</div>

								<div class="cancel-btn flex-center" v-if="item.Status == 0"  @click.stop="cancelOrder(item)">
									<img :src="clearUrl" alt="">
									<span >{{ i18n.t('trade.status3')}}</span>
								</div>
							</div>
							<div class="flex-center-between status">
								<div class="flex-center">
									<span class="tab" :class="item.Trade == 'buy' ? 'green' : 'red'">{{item.Trade == 'buy' ? i18n.t('trade.buy1') : i18n.t('trade.sell1')}}</span>
									<div>{{item.Trust == 'limit' ? i18n.t('trade.label53') : i18n.t('trade.label52')}}</div>
								</div><div class="time">{{formatOrderDateTime(item.CreatedAt)}}</div>
							</div>

							<div class="flex-center list-horizontal-line mt-5">
								<div class="flex-1 label">{{i18n.t('trade.th1')}}</div>
								<div class="flex-1 label text-center">{{i18n.t('trade.th2')}}</div>
								<div class="flex-1 label text-right">{{i18n.t('trade.th3')}}</div>
							</div>

							<div class="flex-center list-horizontal-line">
								<div class="flex-1 ">{{parseFloat(item.TrustClose).toFixed(4)}} USDT</div>
								<div class="flex-1 text-center">{{parseFloat(item.Close).toFixed(4)}} USDT</div>
								<div class="flex-1  text-right">{{parseFloat(item.CloseCount).toFixed(4)}} USDT</div>
							</div>

							<div class="flex-center list-horizontal-line mt-12">
								<div class="flex-1 label">{{i18n.t('trade.th4')}}</div>
								<div class="flex-1 label text-center">{{i18n.t('trade.th5')}}</div>
								<div class="flex-1 label text-right">{{$t('trade.label54')}}</div>
							</div>

							<div class="flex-center list-horizontal-line">
								<div class="flex-1 ">{{parseFloat(item.TrustNum).toFixed(4)}}</div>
								<div class="flex-1 text-center">{{parseFloat(item.CloseNum).toFixed(4)}}</div>
								<div class="flex-1 text-right">{{$t(`trade.status${item.Status + 1}`)}}</div>
							</div>

						</div>

				</div>

				<!--合约-->
				<div class="trade-list black" v-if="tabIndex == 3">
					<div class="list" v-for="(item, i) in orderList" :key="i" @click="toDetail(item)">
						<div class="flex-center-between">
							<div class="list-title flex-center">
									<div class="tab" :class="[item.Direction == 'long' ? 'green' : 'red', i18n.t('trade.label21').length > 12 ? 'small' : '']">{{item.Direction == 'long' ? i18n.t('trade.buy2') : i18n.t('trade.sell2')}}</div>
									<span>{{item.Currency.ShortName}}/USDT </span>
							</div>
							<div class="cancel-btn flex-center" @click.stop="cancelContract(item)" v-if="item.Status == 0">
								<img :src="clearUrl" alt="">
								<span  >{{ i18n.t('trade.status3')}}</span>
							</div>
						</div>
						<div class="flex-center-between status">
							<div>{{item.Full == 'full' ? i18n.t('trade.label1') : i18n.t('trade.label2')}} {{item.Multiple}}X</div>
							<div class="time">{{formatOrderDateTime(item.CreatedAt)}}</div>
						</div>

						<div class="flex-center list-horizontal-line mt-12">
							<div class="flex-2 label">{{i18n.t('trade.th11')}}</div>
							<div class="flex-2 label text-center">{{i18n.t('trade.th7')}}(USDT)</div>
							<div class="flex-2 label text-right">{{i18n.t('trade.th25')}}(USDT)</div>
						</div>


						<div class="flex-center list-horizontal-line">
							<div class="flex-2">{{resetNum(item.OpenNum)}}</div>
							<div class="flex-2 text-center">{{parseFloat(item.Margin).toFixed(4)}}</div>
							<div class="flex-2 text-right">{{parseFloat(item.Profit).toFixed(4)}}</div>
						</div>

						<div class="flex-center list-horizontal-line mt-12">
							<div class="flex-2 label ">{{i18n.t('trade.th10')}}</div>
							<div class="flex-2 label text-center">{{i18n.t('trade.th9')}}</div>
							<div class="flex-2 label text-right">{{i18n.t('trade.th12')}}</div>
						</div>

						<div class="flex-center list-horizontal-line">
							<div class="flex-2 ">{{parseFloat(item.OpenClose).toFixed(4)}}</div>
							<div class="flex-2 text-center">{{parseFloat(item.TrustClose).toFixed(4)}}</div>
							<div class="flex-2 text-right">{{getContractClose(item.OpenClose, item.Multiple, item.Direction)}}</div>
						</div>



						<div class="flex-center-between mt-12 btn-line" v-show="tabActive == 1 && item.Status != 0">
							<div class="list-btn " @click.stop="setWinOrLose(item)">
								{{$t('trade.label11')}}
							</div>
							<div class="list-btn" @click.stop="toClearOrder(item)">{{i18n.t('trade.status5')}}</div>
						</div>

					</div>
				</div>

				<!--期权-->
				<div class="trade-list" v-if="tabIndex == 2">
					<div class="list" v-for="(item, i) in orderList" :key="i" @click="toDetail(item)">
						<div class="flex-center-between">
							<div class="list-title flex-center">

								<span>{{item.Currency.ShortName}}/USDT</span>
							</div>

							<div class="" >
									<div class="time">{{formatOrderDateTime(item.CreatedAt)}}</div>
							</div>
						</div>

						<div class="flex-center-start tag">
							<span class="tab" :class="item.Direction == 'rose' ? 'green' : 'red'">{{item.Direction == 'rose' ? i18n.t('trade.buy3') : i18n.t('trade.sell3')}}</span>
							<div>{{item.Amount || 0}} USDT</div>
						</div>

						<div class="flex-center list-horizontal-line mt-5">
							<div class="flex-1 label">{{i18n.t('trade.th19')}}</div>
							<div class="flex-1 label text-center">{{i18n.t('trade.th21')}}</div>
							<div class="flex-1 label text-right">{{i18n.t('trade.th25')}}</div>
						</div>

						<div class="flex-center list-horizontal-line">
							<div class="flex-1 ">{{parseFloat(item.MarkPrice).toFixed(4)}}</div>
							<div class="flex-1 text-center">{{parseFloat(item.SettlementPrice).toFixed(4)}}</div>
							<div class="flex-1  text-right" :class="item.Profit > 0 ? 'green' : (item.Profit < 0 ? 'red' : '')">{{item.Profit > 0 ? '+' : ''}}{{parseFloat(item.Profit).toFixed(4)}} </div>
						</div>

						<div class="flex-center list-horizontal-line mt-5">
							<div class="flex-1 label">{{i18n.t('trade.label4')}}</div>
							<div class="flex-1 label text-center">{{i18n.t('trade.label14')}}</div>
							<div class="flex-1 label text-right">{{i18n.t('trade.label54')}}</div>
						</div>

						<div class="flex-center list-horizontal-line">
							<div class="flex-1">{{item.Amount}} USDT</div>
							<div class="flex-1 text-center">
								<span v-if="item.Status == 0" class="countdown">{{ getCountdown(item) }}s</span>
								<span v-else>{{item.Settlement}}s</span>
							</div>
							<div class="flex-1 text-right">{{$t(`trade.status${item.Status + 1}`)}}</div>
						</div>
					</div>
				</div>
			</List>


			<div class="order-empty empty-box flex-column-center" v-if="orderList.length == 0 && isInit">
				<img :src="emptyUrl" alt="">
				<span>{{i18n.t('common.empty')}}</span>
			</div>
		</div>
		<!--平仓-->
		<Popup v-model:show="showClearPage" position="bottom" lock-scroll class="rate-popup">
			<clear-page :bitInfo="bitInfo" :showModal="showClearPage" :orderData="orderdetailData" @cancel="cancel" @submit="submitClear"></clear-page>
		</Popup>

			<!--止盈止损设置弹框-->
		<Popup v-model:show="showWinSetting" position="bottom" lock-scroll class="rate-popup">
			<div class="rate-modal">
				<div class="title flex-center-between">
					<div>{{i18n.t('trade.desc25')}}</div>
					<img :src="closeUrl" alt="" @click.stop="cancel">
				</div>
				<div class="win-setting">

					<div class="win-info" >
						<div class="info-line flex-center-between">
							<div class="label">{{i18n.t('trade.th10')}}</div>
							<div>{{parseFloat(winData.OpenClose).toFixed(4)}}</div>
						</div>
						<div class="info-line flex-center-between">
							<div class="label">{{i18n.t('trade.label21')}}</div>
							<div>{{bitInfo.count}}</div>
						</div>
						<div class="info-line flex-center-between">
							<div class="label">{{i18n.t('trade.th12')}}</div>
							<div>{{getContractClose(winData.OpenClose, winData.Multiple, winData.Direction)}}</div>
						</div>
					</div>

					<div class="flex-center-between setting-title">
						<div>{{i18n.t('trade.label24')}}</div>

					</div>

					<div class="trade-money flex-center-between" :class="inputActive7 ? 'active' : ''">
						<div class="left full-width flex-center-between">
							<div class="flex-center icon">
								<img :src="minusUrl" alt="" @click.stop="minusWinMoney(1)">
							</div>
							<div>
								<input type="number" inputmode="decimal" @focus="inputActive7 = true" @blur="checkWinMoney(1)" v-model="winForm.winMoney" :placeholder="i18n.t('trade.label26')">
							</div>
							<div class="flex-center icon">
								<img :src="addUrl2" alt="" @click.stop="addWinMoney(1)">
							</div>
						</div>
					</div>


					<!---止损-->
					<div class="flex-center-between setting-title">
						<div>{{i18n.t('trade.label27')}}</div>

					</div>

					<div class="trade-money flex-center-between" :class="inputActive8 ? 'active' : ''">
						<div class="left flex-center-between">
							<div class="flex-center icon">
								<img :src="minusUrl" alt="" @click.stop="minusWinMoney(2)">
							</div>
							<div>
								<input type="number" inputmode="decimal" @focus="inputActive8 = true" @blur="checkWinMoney(2)" v-model="winForm.loseMoney" :placeholder="i18n.t('trade.label28')">
							</div>
							<div class="flex-center icon">
								<img :src="addUrl2" alt="" @click.stop="addWinMoney(2)">
							</div>
						</div>

					</div>

					<div class="bottom-btn">
						<Button @click.stop="ensureWin">{{i18n.t('trade.btn2')}}</Button>
					</div>
				</div>
			</div>
		</Popup>

		<!--二次确认弹框-->
		<Popup v-model:show="showEnsureModal" position="center" lock-scroll class="ensure-popup">
			<div class="ensure-modal flex-column-center">
				<div class="title" v-if="ensureType == 'option'">{{i18n.t('trade.desc32')}}</div>
				<div class="title" v-if="ensureType == 'cancel' || ensureType == 'cancelContract'">{{i18n.t('trade.desc33')}}</div>
				<div class="flex-center btn-line">
					<Button class="gray" @click.stop="cancel">{{i18n.t('trade.btn1')}}</Button>
					<Button @click.stop="ensureAction">{{i18n.t('trade.btn2')}}</Button>
				</div>
			</div>
		</Popup>
	</div>
</template>
<script>
import topBar from '@/components/topBar'
import { List, Button, Popup, Slider } from 'vant'
import { imitateOptionOrderList, optionOrderList, spotList, cancelSpotOrder, cancelContractOrder, cancelImitateContractOrder, contractOrder, imitateContractOrder, contractList, imitateContractList, tradeHistory, contractSpot, imitateContractSpot, contractLiquidation, imitateContractLiquidation, tradeSetting, updateTradeSetting } from '@/api/trade'
import clearPage from '../trade/clear'
import moment from 'moment';
import 'moment-timezone';
import { formatServerTimeEn, getServerNow } from '@/utils/timeUtils'
export default {
	components: {
		topBar,
		List,
		Button,
		Popup,
		clearPage,
		Slider
	},
  data() {
		return {
			form: {
				status: '0'
			},
			bitInfo: {},
			tabIndex: 1,
			tabActive: 1,
			closeUrl: require('../../assets/imgs/icon-close.png'),
			downUrl: require('../../assets/imgs/icon-arrow-down.png'),
			backUrl: require('../../assets/imgs/icon-back.png'),
			emptyUrl: require('../../assets/imgs/order-empty.png'),
			rightUrl: require('../../assets/imgs/icon-arrow-right.png'),
			clearUrl: require('../../assets/imgs/icon-clear.png'),
			addUrl2: require('../../assets/imgs/icon-add2.png'),
			minusUrl: require('../../assets/imgs/icon-minus.png'),
			orderList: [],
			isInit: false,
      loading: false,
      finished: false,
			page: {
				page: 1,
				pageSize: 10
			},
			totalPage: 1,
			inputActive7: false,
			inputActive8: false,
			showOption: false,
			statusName: this.i18n.t('allOrder.status1'),
			statusList: [
				{
					text: this.i18n.t('allOrder.status1'),
					value: ''
				},
				{
					text: this.i18n.t('allOrder.status2'),
					value: '0'
				},
				{
					text: this.i18n.t('allOrder.status3'),
					value: '1'
				},
				{
					text: this.i18n.t('allOrder.status4'),
					value: '2'
				},
			],
			showClearPage: false,
			orderdetailData: {},
			isCancelOrderEnsure: true,
			showEnsureModal: false,
			showWinSetting: false,
			ensureType: '',
			showMultiplePercent: false,
			showWinPercent: false,
			showLosePercent: false,
			ensureParam: {},
			winData: {},
			winForm: {
				tradeType: 'buy',
				winMoney: '',
				loseMoney: '',
				winPercent: 10,
				losePercent: 10
			},
			multiplePercent: 0,
			winPercent: 0,
			losePercent: 0,
			dataTotal: 0,
			moneySpace: 0.01, // 每次增减金额
			countdownIntervals: {},
		}
	},
	mounted() {
		this.tabIndex = this.$route.query.type ? parseInt(this.$route.query.type) : 1 // 4 模拟期权； 5 模拟合约
		this.initOrder()
		this.bitInfo = JSON.parse(sessionStorage.getItem('bitInfo'))
		this.bitInfo.count = parseFloat(this.bitInfo.count)
		if (this.tabIndex === 2) { // 如果默认显示的是期权订单
			this.setupCountdownIntervals();
		}
	},
	methods: {
		back() {
			this.$router.go(-1)
		},
		onLoad() {
      this.page.page += 1
      this.initOrder(true)
    },
		changeTab(i) {
			this.tabActive = i
			this.form.status = i == 1 ? '0' : '1'
			this.page.page = 1
			this.orderList = []
			this.initOrder()
			if (this.tabIndex === 2) { // 期权订单
				this.$nextTick(() => {
					this.setupCountdownIntervals();
				});
			} else {
				this.clearCountdownIntervals();
			}
		},
		initOrder(isAdd) {
			let form = new FormData()
			form.append('current', this.page.page)
			form.append('pageSize', this.page.pageSize)

			if (this.tabIndex == 1) {// 现货
        if(this.form.status == '0') {
          form.append('Status', '0')
        } else {
          form.append('Status', 1)
        }
				spotList(form).then(res => {
					if (res.data.Items) {
						if (isAdd) {
							this.orderList = this.orderList.concat(res.data.Items)
						} else {
							this.orderList = res.data.Items
						}
						this.totalPage = res.data.Pagination.totalPage
						if (this.tabActive == 1) {
							this.dataTotal = res.data.Pagination.totalRecords
						}
						if (this.totalPage <= this.page.page) {
							this.finished = true;
						}
					}
					this.isInit = true
					this.loading = false
				})
			} else if (this.tabIndex == 3) {// 合约
        if(this.form.status == '0') {
          form.append('Status', '0,1')
        } else {
          form.append('Status', 2)
        }
				contractList(form).then(res => {
					if (res.data.Items) {
						if (isAdd) {
							this.orderList = this.orderList.concat(res.data.Items)
						} else {
							this.orderList = res.data.Items
						}
						this.totalPage = res.data.Pagination.totalPage
						if (this.tabActive == 1) {
							this.dataTotal = res.data.Pagination.totalRecords
						}
						if (this.totalPage <= this.page.page) {
							this.finished = true;
						}
					}
					this.isInit = true
					this.loading = false
				})
			} else if (this.tabIndex == 2) { // 期权
				optionOrderList(form).then(res => {
					if (res.data.Items) {
						if (isAdd) {
							this.orderList = this.orderList.concat(res.data.Items)
						} else {
							this.orderList = res.data.Items
						}
						this.totalPage = res.data.Pagination.totalPage
						if (this.tabActive == 1) {
							this.dataTotal = res.data.Pagination.totalRecords
						}
						if (this.totalPage <= this.page.page) {
							this.finished = true;
						}
					}
					this.isInit = true
					this.loading = false
				})
			} else if (this.tabIndex == 4) { // 模拟期权
				imitateOptionOrderList(form).then(res => {
					if (res.data.Items) {
						if (isAdd) {
							this.orderList = this.orderList.concat(res.data.Items)
						} else {
							this.orderList = res.data.Items
						}
						this.totalPage = res.data.Pagination.totalPage
						if (this.tabActive == 1) {
							this.dataTotal = res.data.Pagination.totalRecords
						}
						if (this.totalPage <= this.page.page) {
							this.finished = true;
						}
					}
					this.isInit = true
					this.loading = false
				})
			} else if (this.tabIndex == 5) { // 模拟合约

				imitateContractList(form).then(res => {
					if (res.data.Items) {
						if (isAdd) {
							this.orderList = this.orderList.concat(res.data.Items)
						} else {
							this.orderList = res.data.Items
						}
						this.totalPage = res.data.Pagination.totalPage
						if (this.tabActive == 1) {
							this.dataTotal = res.data.Pagination.totalRecords
						}
						if (this.totalPage <= this.page.page) {
							this.finished = true;
						}
					}
					this.isInit = true
					this.loading = false
				})
			}
		},
		ensureAction() {
			this.showEnsureModal = false
			if (this.ensureType == 'cancel') {
				this.doCancelOrder(this.ensureParam)
			} else if (this.ensureType == 'option') {
				this.doSubmitOption()
			} else if (this.ensureType == 'cancelContract') {
				this.doCancelContract(this.ensureParam)
			}
		},
		cancelOrder(data) {
			this.showEnsureModal = true
			this.ensureParam = data
			this.ensureType = 'cancel'
		},
		doCancelOrder(data) {
			let form = new FormData()
			form.append('ID', data.ID)
			cancelSpotOrder(form).then(res => {
				if (res.code == 0) {
					this.$toast.success(this.i18n.t('trade.success2'))
					this.initOrder()
				} else {
					this.$toast.fail(res.msg)
				}
			})
		},
		changeOption(data) {
			this.form.status = data.value
			this.statusName = data.text
			this.page.page = 1
			this.showOption = false
			this.initOrder()
		},
		chooseOption() {
			this.showOption = !this.showOption
		},
		toClearOrder(data) {
			this.orderdetailData = data
			this.showClearPage = true
		},
		cancel() {
			this.showClearPage = false
			this.showEnsureModal = false
			this.showWinSetting = false
		},
		submitClear(data) {
			let form = new FormData()
			form.append('ID', this.orderdetailData.ID)
			form.append('PlanTrust', data.type == 1 ? 'market' : 'limit')
			form.append('PlanTrustNum', data.number)
			form.append('PlanTrustPrice', data.price)
			contractLiquidation(form).then(res => {
				if (res.code == 0) {
					this.$toast.success(this.i18n.t('trade.success3'))
					this.showClearPage = false
					this.page.page = 1
					this.initOrder()
				} else {
					this.$toast.fail(res.msg)
				}
			})
		},
		cancelContract(data) {
			this.showEnsureModal = true
			this.ensureParam = data
			this.ensureType = 'cancelContract'
		},
		doCancelContract(data) {
			let form = new FormData()
			form.append('ID', data.ID)
			cancelContractOrder(form).then(res => {
				if (res.code == 0) {
					this.$toast.success(this.i18n.t('trade.success2'))
					this.initOrder()
				} else {
					this.$toast.fail(res.msg)
				}
			})
		},
		//设置止盈止损
		setWinOrLose(data) {
			this.showWinSetting = true
			this.winData = Object.assign({}, data)
			this.winForm.winMoney = data.TakeProfit ? data.TakeProfit.toFixed(this.maxSize) : ''
			this.winForm.loseMoney = data.StopLoss ? data.StopLoss.toFixed(this.maxSize) : ''
		},
		ensureWin() {
			//更改止盈止损价格
			let form = new FormData()
			form.append('ID', this.winData.ID)
			form.append('TakeProfit', this.winForm.winMoney)
			form.append('StopLoss', this.winForm.loseMoney)
			contractSpot(form).then(res => {
				if (res.code == 0) {
					this.$toast.success(this.i18n.t('trade.success3'))
					this.initOrder()
					this.showWinSetting = false
				} else {
					this.$toast.fail(res.msg)
				}
			})
		},
		
		dragWinStart() {
			this.showWinPercent = true
		},
		dragWinEnd() {
			this.showWinPercent = false
		},
		dragLoseStart() {
			this.showLosePercent = true
		},
		dragLoseEnd() {
			this.showLosePercent = false
		},
		checkWinMoney(type) {

			if (type == 1) {
				this.inputActive7 = false
				let newMoney = parseFloat(this.winForm.winMoney)
				this.winForm.winMoney = parseFloat((newMoney).toFixed(this.maxSize))
				if (this.winForm.winMoney < this.bitInfo.count) {
					this.winForm.winMoney = this.bitInfo.count
				}
				this.winForm.winPercent = (this.winForm.winMoney - this.bitInfo.count) / this.bitInfo.count * 100
				this.winPercent = this.winForm.winPercent / 1.5
			} else {
				this.inputActive8 = false
				let newMoney = parseFloat(this.winForm.loseMoney)
				this.winForm.loseMoney = parseFloat((newMoney).toFixed(this.maxSize))
				if (this.winForm.loseMoney > this.bitInfo.count) {
					this.winForm.loseMoney = this.bitInfo.count
				}
				this.winForm.losePercent = (this.bitInfo.count - this.winForm.loseMoney) / this.bitInfo.count * 100
				this.losePercent = this.winForm.losePercent / 0.9
			}
		},
		addWinMoney(type) {
			if (type == 1) {
				let newMoney = this.moneySpace + parseFloat(this.winForm.winMoney) || 0
				this.winForm.winMoney = parseFloat(newMoney.toFixed(2)).toFixed(2)
				this.winForm.winPercent = (this.winForm.winMoney - this.bitInfo.count) / this.bitInfo.count * 100
				this.winPercent = this.winForm.winPercent / 1.5
			} else {
				let newMoney = this.moneySpace + parseFloat(this.winForm.loseMoney) || 0
				this.winForm.loseMoney = parseFloat(newMoney.toFixed(2)).toFixed(2)
				if (this.winForm.loseMoney > this.bitInfo.count) {
					this.winForm.loseMoney = this.bitInfo.count
				}
				this.winForm.losePercent = (this.bitInfo.count - this.winForm.loseMoney) / this.bitInfo.count * 100
				this.losePercent = this.winForm.losePercent / 0.9
			}
		},
		minusWinMoney(type) {
			if (type == 1) {
				let newMoney =  parseFloat(this.winForm.winMoney) - this.moneySpace || 0
				if (newMoney < 0) {
					newMoney = 0
				}
				this.winForm.winMoney = parseFloat(newMoney.toFixed(2)).toFixed(2)
				if (this.winForm.winMoney < this.bitInfo.count) {
					this.winForm.winMoney = this.bitInfo.count
				}
				this.winForm.winPercent = (this.winForm.winMoney - this.bitInfo.count) / this.bitInfo.count * 100
				this.winPercent = this.winForm.winPercent / 1.5
			} else {
				let newMoney =  parseFloat(this.winForm.loseMoney) - this.moneySpace || 0
				if (newMoney < 0) {
					newMoney = 0
				}
				this.winForm.loseMoney = parseFloat(newMoney.toFixed(2)).toFixed(2)
				this.winForm.losePercent = (this.bitInfo.count - this.winForm.loseMoney) / this.bitInfo.count * 100
				this.losePercent = this.winForm.losePercent / 0.9
			}
		},
		toDetail(data) {
			sessionStorage.setItem('orderDetailData', JSON.stringify(data))
			this.$router.push({
				name: 'orderDetail',
				query: {
					type: this.tabIndex
				}
			})
		},
		getContractClose(close, multiple, type) {
			if (type == 'long') {
				return parseFloat((close * (1 - 1 / multiple)).toFixed(4))
			} else {
				return parseFloat((close * (1 + 1 / multiple)).toFixed(4))
			}
		},
		resetNum(num) {
			let newNum = parseFloat(parseFloat(num).toFixed(8))
			let newStr = newNum + ''
			let afterStr = newStr.substring(newStr.indexOf('.') + 1)
			if (afterStr.length > 4) {
				return newStr
			} else {
				newStr += new Array(5 - afterStr.length).join('0')
				return newStr
			}
		},
		formatOrderDateTime(time) {
			return formatServerTimeEn(time, 'YYYY-MM-DD hh:mm:ss A')
		},
		getCountdown(item) {
			if(item.Status !== 0) return item.Settlement;
			
			// 检查Settlement是否为有效数值
			const settlement = parseInt(item.Settlement, 10);
			if (isNaN(settlement) || settlement <= 0) {
				console.error('Invalid Settlement value:', item.Settlement);
				return 0;
			}

			try {
				// 获取服务器时区，默认为 Asia/Shanghai
				const serverTimezone = this.$store.state.timeZone || 'Asia/Shanghai';
				
				// 创建服务器时间（服务器返回的时间是服务器时区的时间）
				const createdAt = moment.tz(item.CreatedAt, serverTimezone);
				// 获取当前服务器时区的时间（基于服务器时间偏移）
				const currentTime = getServerNow();

				// 检查创建时间是否有效
				if (!createdAt.isValid()) {
					console.error('Invalid CreatedAt date:', item.CreatedAt);
					return 0;
				}

				// 计算已经过的秒数（使用服务器时区统一计算）
				const elapsedSeconds = Math.floor(currentTime.diff(createdAt) / 1000);

				// 如果已过时间为负数（可能是服务器时间与本地时间不同步），则返回完整时间
				if (elapsedSeconds < 0) {
					return settlement;
				}

				// 计算剩余秒数 = 总结算秒数 - 已经过秒数
				const remainingSeconds = settlement - elapsedSeconds;

				// 确保不小于0
				return Math.max(0, remainingSeconds);
			} catch (error) {
				console.error('Error calculating countdown:', error);
				return 0;
			}
		},
		setupCountdownIntervals() {
			// 每500ms更新一次倒计时
			this.clearCountdownIntervals(); // 先清除现有的
			
			this.countdownInterval = setInterval(() => {
				if(this.tabIndex == 2 || this.tabIndex == 4) { // 期权订单 或 模拟期权
					this.$forceUpdate(); // 强制视图更新
				}
			}, 500);
		},
		clearCountdownIntervals() {
			if(this.countdownInterval) {
				clearInterval(this.countdownInterval);
				this.countdownInterval = null;
			}
		},
	},
	beforeUnmount() {
		this.clearCountdownIntervals();
	},
}
</script>

<style>
.countdown {
	color: #F7A600;
	font-weight: bold;
}
</style>